/**
 * Created by oleturvoll on 9/5/17.
 */

import {isolarAnalyticsSimpleData} from './isolarAnalyticsSimpleData';
import * as moment from 'moment';

export class solarAnalyticsSummary{
  saData: isolarAnalyticsSimpleData[];
  row: number;
  column: number = 4;  // effectively a const for this datatype
  timestamps: string[];
  days: string[];
  generated: number[];
  consumed: number[];
  netAndInaccurate: any[];

  constructor(data: isolarAnalyticsSimpleData[]){

    this.saData = data;
    this.row = data.length;
    //this needs to all be instantiated when graphingFYI:
    this.timestamps = this.getXAxis();
    this.days = this.getXAxis(true);
    this.generated = this.getGeneratedData();
    this.consumed = this.getConsumedData();
    this.netAndInaccurate = this.getNetAndAccuracy();

  }

  private getOne(num: number): isolarAnalyticsSimpleData{
    return this.saData[num];
  }

  private getDay(num: number,dateonly?: boolean): string{
    if (dateonly === true) {
      return moment(this.getOne(num).t_stamp,'YYYY-MM-DD').format('MMM Do');
    }
    else {
      return this.getOne(num).t_stamp;
    }
  }

  protected getXAxis(dateonly?: boolean): string[]{

    let dayData:string[] = [];
    for(let num in this.saData){
      // this.logger.log.debug(this.getDay(Number(num)));
      dayData.push(this.getDay(Number(num), dateonly));
    }
    return dayData;
  }

  private getGeneratedDataOne(num: number, kWh?: boolean): number{
    if(kWh === false){
      return this.getOne(num).energy_generated;
    } else {
      return Number((this.getOne(num).energy_generated /1000).toFixed(3));
    }
  }

  private getConsumedDataOne(num: number, kWh?: boolean): number{
    if(kWh === false){
      return this.getOne(num).energy_consumed;
    } else {
      return Number((this.getOne(num).energy_consumed /1000).toFixed(3));
    }
  }

  private getNetDataOne(num: number, kWh?: boolean): number{
    let myData:isolarAnalyticsSimpleData = this.getOne(num);
    let net: number = myData.energy_generated-myData.energy_consumed;
    if(kWh === false){
      return net;
    } else {
      return Number((net/1000).toFixed(3));
    }
  }

  private getPredictionAccuracyDataOne(num: number, kWh?: boolean): number{
    let myData:isolarAnalyticsSimpleData = this.getOne(num);
    let net: number = myData.energy_generated-myData.energy_expected;
    if(kWh === false){
      return net;
    } else {
      return Number((net/1000).toFixed(3));
    }
  }

  protected getGeneratedData(): number[]{
    let generatedDataSet:number[] = [];
    for(let num in this.saData){
      // this.logger.log.debug(this.getDay(Number(num)));
      generatedDataSet.push(this.getGeneratedDataOne(Number(num)));
    }

    return generatedDataSet;
  }

  protected getConsumedData(): number[]{
    let consumedDataSet:number[] = [];
    for(let num in this.saData){
      // this.logger.log.debug(this.getDay(Number(num)));
      consumedDataSet.push(this.getConsumedDataOne(Number(num)));
    }

    return consumedDataSet;
  }

  private getNetData(): number[]{
    let netDataSet:number[] = [];
    for(let num in this.saData){
      netDataSet.push(this.getNetDataOne(Number(num)));
    }

    return netDataSet;
  }


  getYAxes(): any[]{

    return [
      { data: this.getGeneratedData(), label: 'Generated Data' },
      { data: this.getConsumedData(), label: 'Consumed Data' }
    ];

  }

  getNetAndAccuracy(): any[]{
    return [
      { data: this.getNetData(), label: 'Net Energy'},
      { data: this.getPredictionAccuracyData(), label: 'Prediction Error'}
    ];
  }

  protected getNetEnergy(): any[]{
    return [
      { data: this.getNetData(), label: 'Net Energy'}
    ];
  }


  private getPredictionAccuracyData(): number[]{
    let predictionAccuracyDataSet:number[] = [];
    for(let num in this.saData){
      predictionAccuracyDataSet.push(this.getPredictionAccuracyDataOne(Number(num)));
    }

    return predictionAccuracyDataSet;
  }

  protected getPredictionAccuracy(): any[]{
    return [
      { data: this.getPredictionAccuracyData(), label: 'Prediction Error'}
    ];
  }
}



// WEBPACK FOOTER //
// ./src/model/meter/solarAnalyticsSummary.ts